export const routes = (prefix = `pharmacy`) => [
    {
        path: `/${prefix}/dispense/:patientID/:visitNO`,
        name: `${prefix}.dispense.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.dispense.create`,
                PageDescription: "Pharmacy - Dispense drugs",
            },
        },
    },
];